import { CREATE_APPOINTMENT, CREATE_APPOINTMENT_ERROR, CREATE_APPOINTMENT_SUCCESS, PAYMENT_CONFIRMED, PAYMENT_CONFIRMED_ERROR, PAYMENT_CONFIRMED_SUCCESS, REQUEST_PAYMENT, REQUEST_PAYMENT_ERROR, REQUEST_PAYMENT_SUCCESS } from './Constants';

// userReducer.js
const initialState = {
    loading: false,
    error: null,
};

export const selectLocationReducer = (state = initialState, action) => {
    switch (action.type) {
    case CREATE_APPOINTMENT:
        return { ...state, loading: true };
    case CREATE_APPOINTMENT_SUCCESS:
        return { ...state, appointmentSuccessData: action.data, loading: true };
    case CREATE_APPOINTMENT_ERROR:
        return { ...state, loading: false };
    case REQUEST_PAYMENT:
        return { ...state, loading: true };
    case REQUEST_PAYMENT_SUCCESS:
        return { ...state, loading: true };
    case REQUEST_PAYMENT_ERROR:
        return { ...state, loading: false };
    case PAYMENT_CONFIRMED:
        return { ...state, loading: true };
    case PAYMENT_CONFIRMED_SUCCESS:        
        return { ...state, paymentData : action.data, loading: false };
    case PAYMENT_CONFIRMED_ERROR:
        return { ...state, loading: false };
    default:
        return state;
    }
};
